import useAuthBoards from '@apps/www/src/www/hooks/useAuthBoards';
import useAuthTeam from '@apps/www/src/www/hooks/useAuthTeam';
import BoardOwnershipType from '@pkgs/shared/enums/BoardOwnershipType';
import TeamUserRole from '@pkgs/shared/enums/TeamUserRole';
import teamUserRoleHasTeamUserRolePrivileges from '@pkgs/shared/helpers/teamUserRoleHasTeamUserRolePrivileges';

/**
 * This checks if the team side menu should be rendered.
 * It checks if the user has admin privileges or if the user has boards.
 */

const useIsTeamSideMenuRendered = () => {
	const team = useAuthTeam();
	const teamBoards = useAuthBoards()?.filter(
		(board) => board.ownershipType === BoardOwnershipType.TEAM,
	);

	if (!team) {
		return false;
	}

	if (teamUserRoleHasTeamUserRolePrivileges(team.role, TeamUserRole.ADMIN)) {
		return true;
	}

	return !!teamBoards?.length;
};

export default useIsTeamSideMenuRendered;
